






























































































































































































































































































































import PluginComponent from '@/components/plugins/PluginComponent';
import { EVENTS } from '@/services/EventBus';
import Component from 'vue-class-component';
import axios, { Canceler } from 'axios';
import { GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import { transformExtent } from 'ol/proj';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import VectorSource from 'ol/source/Vector';
import AdministrativeArea from '@/models/shared/AdministrativeArea';
import LayerGroupConfig from '@/models/map-context/LayerGroupConfig';
import LayerConfig from '@/models/map-context/LayerConfig';
import AbstractLayerTreeElement from '@/models/map-context/AbstractLayerTreeElement';
import FileSaver from 'file-saver';
import LayerAttribute from '@/models/map-context/LayerAttribute';
import LayerLegend from '../legend/LayerLegend.vue';
import { BIcon } from 'bootstrap-vue';
import { disable } from 'ol/rotationconstraint';
@Component({
  props: {
  },
  components: {
    LayerLegend,
    BIcon
  },
})
export default class CnesPlugin extends PluginComponent {
  static ID = 'CnesPlugin';

  addresses = [];
  millesimes = ['2020', '2025'];
  millesimesref = ['', '2020', '2025'];

  currentmillesime = null ;

  refmillesime: string = '';
  lastDiff:any=null;
  addressSearch = '';
  proportion_indic_sources: string = "0.5";
  indicateurs = [{
    name:'artificialisation',
    indicProperty:'taux_artif',
    groupTitle:'Artificialisation',
    millesimes : [ '2020','2024'],
    millesimesref : ['2020','2024']

  }, {name:'occupation_fonciere',
      indicProperty:'classe_majoritaire',
      groupTitle:'Occupation foncière',
      millesimes : ['2020', '2025'],
      millesimesref : ['', '2020', '2025']}, 
      {name:'chantiers',
    groupTitle:'Chantiers',
    millesimes : ['2020', '2025'],
    millesimesref : ['', '2020', '2025']
  },
  {name:'sites_logistiques',
    groupTitle:'Indic3',
    millesimes : ['2020', '2025'],
    millesimesref : ['', '2020', '2025']
  }];
  currentIndic:any=null;
  administrativeAreasConfig = {
    label: 'Localisations',
    wfsUrl: '/geoserver/wfs?SERVICE=WFS&VERSION=2.0.0',//http://localhost/cnes_rec
    layer: 'neogeo:localisations',
    attributeSearch: 'nom_officiel',
    autocomplete: true,
  };

  private cancelRequest: Canceler | null = null;

  administrativeArea: AdministrativeArea = new AdministrativeArea(this.administrativeAreasConfig);

  selectedZone: any = null;
  featureSource: any;
  olLayer: any;
  selectedFeatureZone: any = null;
  difffeatureSource: any;
  millesimeObsLayer: any= null;
  showDifference = false;
  swipeLayer: any = null;
  swipe: any = null;
  swipeActive: boolean = false;
  selectedIndicatorGroup!: LayerGroupConfig;
  selectedSourceGroup!: LayerGroupConfig;
  artifref:any=null;
  artifcurrent:any=null;
  artifDiff:any=null;
  nonartifDiff:any=null;
  batiref:any=null;
  baticurrent:any=null;
  mounted(): void {
    if(this.contextService.configuration.custom && this.contextService.configuration.custom.indicateurs){
      this.indicateurs=this.contextService.configuration.custom.indicateurs;
    }
    this.getEventBus().$on(EVENTS.MAP_CURRENT_BBOX_CHANGE, (bbox: any) => this.onMoveEnd(bbox));
    this.swipe = document.getElementById('swipe');
    let indicator = this.$route.query.indic;
    if(indicator && indicator.length>0){
      this.selectIndic(indicator.toString());
    }
    else{
      this.selectIndic('artificialisation');
    }
    
    
  }

  refreshProportionIndicSources(){
    if(this.millesimeObsLayer){
      if(this.proportion_indic_sources=="0"){
        this.millesimeObsLayer.setVisible(false);
      }
      else{
        this.millesimeObsLayer.setVisible(true);
      }
      this.millesimeObsLayer.setOpacity(parseFloat(this.proportion_indic_sources));
    }

    
    this.selectedSourceGroup.childs.forEach((child: AbstractLayerTreeElement) => {
      if (child instanceof LayerConfig) {
        if(child!=this.millesimeObsLayer){
           if(this.proportion_indic_sources=="1"){
            child.setVisible(false);
          }
          else{
            child.setVisible(true);
          }
          let prop=1-parseFloat(this.proportion_indic_sources);
          child.setOpacity(Number(prop.toFixed(2)));
        }
      }
    });
  }
  onChangeMillesime(millesime: any) {
    console.log(millesime);
    /*if(this.refmillesime!=""){
      this.resetDiff();
    }*/
    this.updateDisableState();
    this.calculTaux()
    this.selectedIndicatorGroup.childs.forEach((child: AbstractLayerTreeElement) => {
      if (child instanceof LayerConfig) {
        child.filter = `millesime='${millesime}'`;
        child.getLayerSource().refresh();
      }
    });
    this.selectedSourceGroup.childs.forEach((child: AbstractLayerTreeElement) => {
      if (child instanceof LayerConfig) {
        if(child.layername=="neogeo:chantiers"){
          child.filter = `annee=${millesime}`;
        }else{
          child.filter = `millesime='${millesime}'`;
        }
        
        child.getLayerSource().refresh();
        child.clearCache();
        this.getMapService().removeLayerFromMap(child);
        this.getMapService().addLayer(child);
      }
    });
  }
  download(format:string,layerConfig?:LayerConfig) {
    let wfsUrl = this.millesimeObsLayer.getWFSUrl(this.getMapService().getMapExtent(), 'EPSG:3857',true);
    if(layerConfig!=undefined){
      wfsUrl = layerConfig.getWFSUrl(this.getMapService().getMapExtent(), 'EPSG:3857',true);
    }
    

    wfsUrl += ` AND INTERSECTS(geometry, querySingle('neogeo:localisations', 'geometry','nom_officiel = ''${this.selectedFeatureZone.get(
      'nom_officiel'
    )}'''))`;
    console.log(wfsUrl);
    wfsUrl=wfsUrl.replace('outputFormat=application%2Fjson', `outputFormat=${format}`);
    let output=`result.${format}`;
    if( format=='Geopackage'){
      output=`result.gpkg`;
      let typenames: string[] = [];
      this.selectedIndicatorGroup.childs.forEach((child: AbstractLayerTreeElement) => {
        if (child instanceof LayerConfig) {
          typenames.push(`${child.layername}`);
        }
      });
      wfsUrl=wfsUrl.replaceAll(this.millesimeObsLayer.layername, typenames.join(','));
    }
    
    // USE POST if URL too long
    if (wfsUrl.length > 4000) {
      const urlArray = wfsUrl.split('?');
      axios.post(urlArray[0], urlArray[1], { responseType: 'blob' }).then((result) => {
        FileSaver.saveAs(result.data, output);
      });
    } else {
      FileSaver.saveAs(wfsUrl, output);
    }
  }

  resetDiff() {
    this.refmillesime="";
    this.reset();
  }

  getIndicateurByName(name:string){
    return this.indicateurs.find((x:any)=>x.name==name);
  }

  reset() {
    this.millesimeObsLayer.setVisible(true);
    this.difffeatureSource.clear();
  }

  disableSwipeLayer() {
    this.millesimeObsLayer.getOlLayer().un('prerender', this.prerender);
    this.millesimeObsLayer.getOlLayer().un('postrender', this.postrender);
    this.swipeActive = false;
    this.getMapService().removeLayerFromList(this.swipeLayer);
    this.getMapService().removeLayerFromMap(this.swipeLayer);
    this.getEventBus().$emit(EVENTS.SWIPE_ENABLED, false);
  }
  showMetadatas(){
    let url=this.millesimeObsLayer.metadataUrl;
    window.open(url, '_blank');
  }
  activeSwipeLayer() {
    if(this.swipeActive==false){
      this.swipeActive = true;
      //this.reset();
      let h: LayerConfig = this.millesimeObsLayer;
      let jsonDef = this.millesimeObsLayer.toJsonDuplication();
      delete jsonDef.indicators;
      this.swipeLayer = new LayerConfig(jsonDef);
      this.swipeLayer.filter = `millesime='${this.refmillesime}'`;
      this.swipeLayer.opacity = 1;
      this.millesimeObsLayer.setOpacity(1);
      this.getMapService().addLayerToMap(this.swipeLayer);
      //INSERT INTO GROUP IF ANY
      if (this.millesimeObsLayer.parent) {
        this.getMapService().changeLayerOrder(this.swipeLayer, this.millesimeObsLayer, 'after');
      }

      this.getEventBus().$emit(EVENTS.SWIPE_ENABLED, true);
      this.activeSwipe();
    }else{
      this.disableSwipeLayer();
    }
  }
  prerender(event: any) {
    this.getMapService().preRenderSwipe(event, this.swipe.value, true);
  }

  postrender(event: any) {
    this.getMapService().postRenderSwipe(
      event,
      this.swipe.value,
      true,
      this.currentmillesime,
      this.refmillesime
    );
  }
  activeSwipe() {
    this.millesimeObsLayer.getOlLayer().un('prerender', this.prerender);
    this.millesimeObsLayer.getOlLayer().un('postrender', this.postrender);
    this.millesimeObsLayer.getOlLayer().on('prerender', this.prerender);
    this.millesimeObsLayer.getOlLayer().on('postrender', this.postrender);
  }
  getActiveChild(group:LayerGroupConfig){
    let liste=this.selectedIndicatorGroup.childs.filter((x:any)=>x.inRange(this.getMapService().currentScale));
    if(liste.length==1){
      return liste[0];
    }
    throw new Error('No active indicator');
  }

  calculTaux(){
    if(this.selectedFeatureZone){
      let bassin:any = this.selectedIndicatorGroup.childs.filter((x:any)=>x.layername.includes("bassin"))[0];
      let wfsurl=bassin.getWFSUrl(this.getMapService().getMapExtent(), 'EPSG:3857',true);
      wfsurl=wfsurl.replace(/CQL_FILTER=.*/,``);
      wfsurl += `CQL_FILTER=uid = '${this.selectedFeatureZone.get(
        'cleabs')}'`;
      console.log(wfsurl);
      fetch(wfsurl)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.batiref=null;
          this.baticurrent=null;
          if(data.features.length>0){
            
            if(this.currentIndic.name=="artificialisation"){
              this.artifref=data.features.filter((f:any)=>f.properties.millesime==this.refmillesime)[0].properties.taux_artif;
              this.artifcurrent=data.features.filter((f:any)=>f.properties.millesime==this.currentmillesime)[0].properties.taux_artif;
              this.artifDiff=Math.round((this.artifcurrent-this.artifref)*100)/100;
              this.nonartifDiff=Math.round(((100-this.artifcurrent)-(100-this.artifref))*100)/100;
              console.log(this.artifref,this.artifcurrent);
            }else{
              this.batiref=data.features.filter((f:any)=>f.properties.millesime==this.refmillesime)[0].properties;
              this.baticurrent=data.features.filter((f:any)=>f.properties.millesime==this.currentmillesime)[0].properties;
            
              console.log(this.batiref,this.baticurrent);
            }
          }
          //this.selectedZone+=` - Taux d'artificialisation : ${data.features[0].properties.taux_artif} %`;
        });
    }
   

  }
  updateDisableState(){
    this.millesimes.forEach((millesime:any)=>{
     if(Number(millesime.value)<Number(this.refmillesime)){
      millesime.disabled=true;
     }else{      
      millesime.disabled=false;
     }
    });
     this.millesimesref.forEach((millesime:any)=>{
     if(Number(millesime.value)>Number(this.currentmillesime)){
      millesime.disabled=true;
     }else{      
      millesime.disabled=false;
     }
    });
  }
  onChangeRefMillesime(millesime: any,clear=true) {
    console.log(millesime);
    this.updateDisableState();
    this.calculTaux()
    this.millesimeObsLayer = this.getActiveChild(this.selectedIndicatorGroup);
    this.selectedIndicatorGroup.childs.forEach((x: any) => x.setVisible(true));
    //this.millesimeObsLayer.setVisible(false);
    let currentFeatures = this.millesimeObsLayer.getLayerSource().getFeatures();
    let jsonDef = this.millesimeObsLayer.toJsonDuplication();
    let idProperty=this.millesimeObsLayer.getIdPropery();
    let indicProperty=this.currentIndic.indicProperty;
    if(this.millesimeObsLayer.layerProperties.find((x:LayerAttribute)=>x.name=="percentage")){
      indicProperty='percentage';
    }
    if(this.millesimeObsLayer.layerProperties.find((x:LayerAttribute)=>x.name=="objectid")){
      idProperty='objectid'; 
    }else if(this.millesimeObsLayer.layerProperties.find((x:LayerAttribute)=>x.name=="uid")){
      idProperty='uid'; 
    }
    else{
      idProperty='cleabs';
    }

      
    let layerCfg = new LayerConfig(jsonDef);
    layerCfg.filter = `millesime='${millesime}'`;
    //this.addDifferenceVectorLayer();
    /*
    let url = layerCfg.getWFSUrl(this.getMapService().getMapExtent(), 'EPSG:3857');
    if(clear){
      this.difffeatureSource.clear();
    }
   
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data.features);
        let toadd: any = [];
        data.features.forEach((f: any) => {
          let current = currentFeatures.find(
            (x: any) => x.get(idProperty) == f.properties[idProperty]
          );
          if (current && current.get(indicProperty) != f.properties[indicProperty]) {
            let clone = current.clone();
            if (current.get(indicProperty) > f.properties[indicProperty]) {
              clone.set('color', 'green');
            }
            else {
              clone.set('color', 'red');
            }
            toadd.push(clone);
          }
        });
        if(this.lastDiff==null || !this.areEquals(this.lastDiff,toadd)){
          if(!clear){
            this.difffeatureSource.clear();
          }
          this.lastDiff=toadd;
          this.difffeatureSource.addFeatures(toadd);
        }
        
        this.showDifference = true;
      });
      console.log(url); 
       */
    
  }

  areEquals(a:any,b:any){
    if(a.length!=b.length){
      return false;
    }
    for(let i=0;i<a.length;i++){
      if(a[i].get("cleabs")!=b[i].get("cleabs")){
        return false;
      }
    }
    return true;
  }


  onMoveEnd(bbox: any): void {
    console.log(bbox);
    if( this.millesimeObsLayer != this.getActiveChild(this.selectedIndicatorGroup)){
      this.millesimeObsLayer=this.getActiveChild(this.selectedIndicatorGroup);

      if(this.swipeActive){
        this.disableSwipeLayer();
        this.activeSwipeLayer();
      }else if(this.refmillesime && this.refmillesime!=""){
        this.onChangeRefMillesime(this.refmillesime);
      }
      this.refreshProportionIndicSources();
    }
    else if(this.refmillesime && this.refmillesime!="" && !this.swipeActive){
      this.onChangeRefMillesime(this.refmillesime,false);
      this.refreshProportionIndicSources();
    }
  }

  addVectorLayer() {
    if (!this.featureSource) {
      this.featureSource = new VectorSource();

      this.olLayer = new VectorLayer({
        source: this.featureSource,
        style: new Style({
          stroke: new Stroke({
            color: 'white',
            width: 3,
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.01)',
          }),
        }),
      });
      this.olLayer.setZIndex(80);
      this.getOpenLayersMapService().map.addLayer(this.olLayer);
    } else {
      this.featureSource.clear();
    }
  }

  addDifferenceVectorLayer() {
    if (!this.difffeatureSource) {
      this.difffeatureSource = new VectorSource();

      this.olLayer = new VectorLayer({
        source: this.difffeatureSource,
        style: {
          'fill-color': ['get', 'color'],
        },
      });
      this.olLayer.setZIndex(80);
      this.getOpenLayersMapService().map.addLayer(this.olLayer);
    }/* else {
      this.difffeatureSource.clear();
    }*/
  }

  selectAddresse(event: any): void {
    console.log(event);
    this.selectedFeatureZone = null;
    if (event.bbox) {
      const attributeSearch: any = this.administrativeArea.attributeSearch;
      this.selectedZone = event.properties[attributeSearch];
    } else {
      this.selectedZone = event;
    }

    this.administrativeArea.loadFeature(this.selectedZone).then((retour) => {
      console.log(retour);
      this.contextService.loading = false;
      this.getEventBus().$emit(EVENTS.INFO, '');
      const featureList = new GeoJSON().readFeatures(retour.data);
      if (featureList && featureList.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedFeatureZone = featureList[0];
        this.getOpenLayersMapService().zoomToFeature(this.selectedFeatureZone,[300,300,300,300]);
        this.addVectorLayer();
        this.featureSource.addFeatures(featureList);
        this.calculTaux();
      }
    });
  }

  selectIndic(indic: string): void {
     this.currentIndic = this.getIndicateurByName(indic);
     //if(this.currentmillesime==null){
      this.currentmillesime=this.currentIndic.millesimes[this.currentIndic.millesimesref.length -1];
      this.refmillesime=this.currentIndic.millesimes[0];
     //}
    //this.getEventBus().$emit(EVENTS.CNES_INDICATOR_SELECTED, indic);
    this.indicateurs.forEach((x:any)=>{
      let layerGroup = this.getMapService().config.getLayerGroupByTitle(x.groupTitle);
      layerGroup.setVisible(false);
      
      if(x.name==indic){
        this.selectedIndicatorGroup=layerGroup.childs[0] as LayerGroupConfig;
        this.selectedSourceGroup=layerGroup.childs[1] as LayerGroupConfig;
        layerGroup.setVisible(true);
        this.millesimes=x.millesimes.map((m:any)=>{ return {value:m,label:m,disabled:false}});
        this.millesimesref=x.millesimesref.map((m:any)=>{ return {value:m,label:m,disabled:false}});
      
      }
    });
    this.millesimeObsLayer = null;
    if(indic!="chantiers"){
      this.millesimeObsLayer = this.getActiveChild(this.selectedIndicatorGroup);
    }
    else{
      this.proportion_indic_sources="0";
    }
    this.onChangeMillesime(this.currentmillesime);
    this.refreshProportionIndicSources();
  }
  getTerritoires(query: string, loading: (monParametre: boolean) => void): void {
    // Annulez la requête précédente si elle existe
    if (this.cancelRequest) {
      this.cancelRequest();
    }
    // Créez une nouvelle fonction d'annulation pour la nouvelle requête
    const { token, cancel } = axios.CancelToken.source();
    this.cancelRequest = cancel;
    if (loading) {
      loading(true);
    }
    else{
      query="";
    }
    let additionalFilter='';
    if(this.currentIndic && this.currentIndic.name=='artificialisation'){
        additionalFilter=' AND ism1=\'true\''
      }
      if(this.currentIndic && this.currentIndic.name=='occupation_fonciere'){
        additionalFilter=' AND ism2=\'true\''
      }
    this.administrativeArea
      .loadDatas("!"+query,additionalFilter)
      .then((retour) => {
        this.addresses = retour.data.features;
        console.log(this.addresses);
        
        console.log(this.addresses);
      })
      .catch(() => {
        this.addresses = [];
      })
      .finally(() => loading(false));
  }

  getOptionLabel(s: any): string {
    return s.properties.nom_officiel;
  }
}
